module.exports = __webpack_public_path__ + "media/djembe_pof.713dec33.wav";